module.exports = __webpack_public_path__ + "img/close-x.e0daaa1b.svg";